/*!
 * @Author: luoob
 * @Date: 2020-11-04 16:50:00
 * @Last Modified by: luoob
 * @Last Modified time: 2020-11-04 16:50:00
 * @Instruduction: 线索服务接口
 */

import xhr from './xhr/index'
import { BaseParams, DetailParams } from './index'

interface IGetClueListParams {
    clue_type_id?: number                     // 线索分类 id
    channel_id?: number                       // 渠道 id
    clue_source_id?: number                   // 数据源 id
    user_report?: number                      // 用户线索筛选 0:全部(默认) 1:系统 2:用户
    page_index?: number                       // 第几页
    page_size?: number                        // 每页条数
    sort?: string                             // 排序
    status?: number                          // 0:未审核 1:通过 2:不通过
}

interface IGetClueDetailParams {
    id: number                                 // 线索 id
}

interface ICreateClueParams {
    clue_type_id: number                      // 线索分类 id
    title: string                             // 标题
    content: string                           // 内容
    images: string[]                          // 图片列表
    province: string                          // 省份
    city: string                              // 城市
    area: string                              // 区
}

interface IUpdateClueParams {
    id: number                                 // 线索 id
    clue_type_id?: number                      // 线索分类 id
    title?: string                             // 标题
    content?: string                           // 内容
    images?: string[]                          // 图片列表
    province?: string                          // 省份
    city?: string                              // 城市
    area?: string                              // 区
    top?: number                               // 是否置顶
}

interface IDeleteClueParams {
    id: number								   // 线索 id
}

interface ISuggestTipParams {
    keyword: string                           // 输入的文字
    table: string                             // 提示的表名 channel:渠道 clue_source:线索源
    page_index?: number                       // 第几页
    page_size?: number                        // 每页几条
}

interface IGetChannelListParams {
    name?: string                             // 渠道名（模糊匹配）
    page_index?: number                       // 第几页
    page_size?: number                        // 每页几条
}

interface ICreateChannelParams {
    logo: string                               // logo        
    name: string                               // 渠道名
    official_url: string                       // 官网地址
    is_gov: boolean                            // 是否政策
    is_pyppeteer: boolean                      // 是否需要绕过爬虫
}

interface IUpdateChannelParams {
    id: number                                 // 渠道 id
    logo: string                               // logo
    name: string                               // 渠道名
    official_url: string                       // 官网地址
    is_gov: boolean                            // 是否政策
    is_pyppeteer: boolean                      // 是否需要绕过爬虫
}

interface ICreateClueSortParams {
    name: string                               // 线索分类名称
}

interface IUpdateClueSortParams {
    id: number                                // 线索分类id
    name: string                              // 线索分类名称
}

interface ICreateDSSParams {
    name: string                               // 线索源分类名
}

interface IUpdateDSSParams {
    id: number                                // 线索源分类 id
    name: string                              // 线索源分类名
}

interface IDeleteDSSParams {
    id: number                                 // 线索源分类 id
}

interface IGetChannelSourceListParams {
    channel_id?: number                       // 渠道 id
    page_index?: number                       // 第几页
    page_size?: number                        // 每页条数
}

interface IGetChannelSourceDetailParams {
    id: number                                 // 线索源 id
}

interface ICreateChannelSourceParams {
    channel_id: number                        // 渠道 id
    name: string                              // 名称
    clue_source_type_id: number               // 线索源分类 id
    official_url: string                      // 官网
}

interface IUpdateChannelSourceParams {
    id: number                                // 线索源 id
    name: string                              // 名称
    clue_source_type_id: number               // 线索源分类 id
    official_url: string                      // 官网
    is_generic: boolean                       // 是否通用爬虫
}

interface IDeleteChannelSourceParams {
    id: number                                 // 线索源 id
}

interface IUpdateChannelShowParams {
    id: number                                // 线索 id
    status: number                              // 审核状态
}

interface IDeleteChannelParams {
    id: number                                 // 渠道 id
}

interface IGetLevyListParams {
    page_index?: number                       // 第几页
    page_size?: number                        // 每页条数
}

interface IGetLevyDetailParams {
    id: number                                 // 征集 id
}

interface IGetLevyDetailParams {
    id: number                                 // 征集 id
}

interface ICreateLevyParams {
    title: string                             // 标题
    content: string                           // 内容
    images: string[]                          // 图片列表
}

interface IUpdateLevyShowParams {
    id: number                                // 征集 id
    show: boolean                             // 是否允许查看
}

interface IDeleteLevyParams {
    id: number                                 // 征集 id
}

interface IUpdateLevyParams {
    id: number
    top?: boolean
    status?: number 
}

interface IGetClueRecommendList {}

interface IGetClueRecommendDetail {
    id: number
}

interface ICreateClueRecommend {
    order: number                       // 顺序
    title: string                       // 线索标题
    cover_img: string                   // 线索封面图
    published_at: string                // 发表时间
    url: string                         // 页面链接
}

interface IUpdateClueRecommend {
    id: number                          // 编号
    order: number                       // 顺序
    title: string                       // 线索标题
    cover_img: string                   // 线索封面图
    published_at: string                // 发表时间
    url: string                         // 页面链接
}

interface IDeleteClueRecommend {
    id: number                           // 编号
}

interface IGetCommentList {
    clue_id?: number                    // 线索 id
    user_id?: string                    // 用户 id
    page_index?: number                 // 第几页
    page_size?: number                  // 每页条数
}

interface IGetClueReportedList extends BaseParams {}

interface ICreateClueReported {
    clue_id: number                      // 线索 id
    medium_name: string                  // 报道的媒体名
    published_at: string                 // 报道的时间
}

interface IUpdateClueReported {
    id: number                           // 线索被报道记录的 id
    clue_id: number                      // 线索 id
    medium_name: string                  // 报道的媒体名
    published_at: string                 // 报道的时间
}

interface IDeleteClueReported {
    id: number                           // 线索被报道记录的 id
}

interface IGetReleaseListParams extends BaseParams {
    status: number                       // 审核状态 0:全部(默认) 1:审核中 2:已通过 3:不通过
}

interface IGetReleaseDetailParams extends DetailParams {}

interface IUpdateReleaseParams {
    id: number                           // 发布会 id
    status: number                       // 审核状态 1:审核中 2:已通过 3:不通过
}

class ClueService {

    /** 获取线索列表 */
    public async getClueList(params: IGetClueListParams) {
        const result = await xhr({
            method: 'get',
            url: '/clue/list',
            params: params
        })
        return result
    }

    /** 获取线索详情 */
    public async getClueDetail(params: IGetClueDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/clue',
            params: params
        })
        return result
    }

    /** 新增线索 */
    public async createClue(params: ICreateClueParams) {
        const result = await xhr({
            method: 'post',
            url: '/clue',
            params: params
        })
        return result
    }

    /** 修改线索 */
    public async updateClue(params: IUpdateClueParams) {
        const result = await xhr({
            method: 'put',
            url: '/clue',
            params: params
        })
        return result
    }

    /** 删除线索 */
    public async deleteClue(params: IDeleteClueParams) {
        const result = await xhr({
            method: 'delete',
            url: '/clue',
            params: params
        })
        return result
    }

    /** 修改线索展示状态 */
    public async updateChannelShow(params: IUpdateChannelShowParams) {
        const result = await xhr({
            method: 'put',
            url: '/clue/show',
            params: params
        })
        return result
    }

    /** 修改线索置顶状态 */
    public async updateClueTop(params: { id: number, top: number }) {
        const result = await xhr({
            method: 'put',
            url: '/clue/top',
            params: params
        })
        return result
    }

    /** 搜索提示 */
    public async suggestTip(params: ISuggestTipParams) {
        const result = await xhr({
            method: 'get',
            url: '/suggestion',
            params: params
        })
        return result
    }

    /** 线索分类 */
    public async getClueSortList() {
        const result = await xhr({
            method: 'get',
            url: '/clue_type/list',
            params: null
        })
        return result
    }

    /** 新增线索分类 */
    public async createClueSort(params: ICreateClueSortParams) {
        const result = await xhr({
            method: 'post',
            url: '/clue_type',
            params: params
        })
        return result
    }

    /** 修改线索分类 */
    public async updateClueSort(params: IUpdateClueSortParams) {
        const result = await xhr({
            method: 'put',
            url: '/clue_type',
            params: params
        })
        return result
    }

    /** 渠道列表 */
    public async getChannelList(params: IGetChannelListParams) {
        const result = await xhr({
            method: 'get',
            url: '/channel/list',
            params: params
        })
        return result
    }

    /** 新增渠道 */
    public async createChannel(params: ICreateChannelParams) {
        const result = await xhr({
            method: 'post',
            url: '/channel',
            params: params
        })
        return result
    }

    /** 修改渠道 */
    public async updateChannel(params: IUpdateChannelParams) {
        const result = await xhr({
            method: 'put',
            url: '/channel',
            params: params
        })
        return result
    }

    /** 修改渠道 */
    public async deleteChannel(params: IDeleteChannelParams) {
        const result = await xhr({
            method: 'delete',
            url: '/channel',
            params: params
        })
        return result
    }

    /** 获取数据源分类列表 DataSourceSort */
    public async getDataSourceSortList() {
        const result = await xhr({
            method: 'get',
            url: '/clue_source_type/list',
            params: null
        })
        return result
    }

    /** 新增数据源分类 DataSourceSort */
    public async createDataSourceSort(params: ICreateDSSParams) {
        const result = await xhr({
            method: 'post',
            url: '/clue_source_type',
            params: params
        })
        return result
    }

    /** 修改数据源分类 DataSourceSort */
    public async updateDataSourceSort(params: IUpdateDSSParams) {
        const result = await xhr({
            method: 'put',
            url: '/clue_source_type',
            params: params
        })
        return result
    }

    /** 删除数据源分类 DataSourceSort */
    public async deleteDataSourceSort(params: IDeleteDSSParams) {
        const result = await xhr({
            method: 'delete',
            url: '/clue_source_type',
            params: params
        })
        return result
    }

    /** 某渠道下的数据源列表 */
    public async getChannelSourceList(params: IGetChannelSourceListParams) {
        const result = await xhr({
            method: 'get',
            url: '/clue/_source/list',
            params: params
        })
        return result
    }
    
    /** 数据源详情 */
    public async getChannelSourceDetail(params: IGetChannelSourceDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/clue/_source',
            params: params
        })
        return result
    }

    /** 新增数据源 */
    public async createChannelSource(params: ICreateChannelSourceParams) {
        const result = await xhr({
            method: 'post',
            url: '/clue/_source',
            params: params
        })
        return result
    }

    /** 修改数据源 */
    public async updateChannelSource(params: IUpdateChannelSourceParams) {
        const result = await xhr({
            method: 'put',
            url: '/clue/_source',
            params: params
        })
        return result
    }

    /** 删除数据源 */
    public async deleteChannelSource(params: IDeleteChannelSourceParams) {
        const result = await xhr({
            method: 'delete',
            url: '/clue/_source',
            params: params
        })
        return result
    }

    /** 获取征集列表 */
    public async getLevyList(params: IGetLevyListParams) {
        const result = await xhr({
            method: 'get',
            url: '/levy/list',
            params: params
        })
        return result
    }

    /** 获取征集详情 */
    public async getLevyDetail(params: IGetLevyDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/levy',
            params: params
        })
        return result
    }

    /** 新增征集 */
    public async createLevy(params: ICreateLevyParams) {
        const result = await xhr({
            method: 'post',
            url: '/levy',
            params: params
        })
        return result
    }

    /** 修改征集 */
    public async updateLevy(params: IUpdateLevyParams) {
        const result = await xhr({
            method: 'put',
            url: '/levy',
            params: params
        })
        return result
    }

    /** 删除征集 */
    public async deleteLevy(params: IDeleteLevyParams) {
        const result = await xhr({
            method: 'delete',
            url: '/levy',
            params: params
        })
        return result
    }

    /** 修改征集展示状态 */
    public async updateLevyShow(params: IUpdateLevyShowParams) {
        const result = await xhr({
            method: 'put',
            url: '/levy/show',
            params: params
        })
        return result
    }

    /** 推荐线索列表 */
    public async getClueRecommendList(params: IGetClueRecommendList) {
        const result = await xhr({
            method: 'get',
            url: '/clue/recommend/list',
            params: params
        })
        return result
    }

    /** 推荐线索详情 */
    public async getClueRecommendDetail(params: IGetClueRecommendDetail) {
        const result = await xhr({
            method: 'get',
            url: '/clue/recommend',
            params: params
        })
        return result
    }

    /** 创建推荐线索 */
    public async createClueRecommend(params: ICreateClueRecommend) {
        const result = await xhr({
            method: 'post',
            url: '/clue/recommend',
            params: params
        })
        return result
    }

    /** 修改推荐线索 */
    public async updateClueRecommend(params: IUpdateClueRecommend) {
        const result = await xhr({
            method: 'put',
            url: '/clue/recommend',
            params: params
        })
        return result
    }

    /** 删除推荐线索 */
    public async deleteClueRecommend(params: IDeleteClueRecommend) {
        const result = await xhr({
            method: 'delete',
            url: '/clue/recommend',
            params: params
        })
        return result
    }

    /** 获取评论列表 */
    public async getCommentList(params: IGetCommentList) {
        const result = await xhr({
            method: 'get',
            url: '/clue/comment/list',
            params: params
        })
        return result
    }

    /** 已被报道的线索记录 */
    public async getClueReported(params: IGetClueReportedList) {
        const result = await xhr({
            method: 'get',
            url: '/clue/report/list',
            params: params
        })
        return result
    }

    /** 新增已被报道的线索记录 */
    public async createClueReported(params: ICreateClueReported) {
        const result = await xhr({
            method: 'post',
            url: '/clue/report',
            params: params
        })
        return result
    }

    /** 更新已被报道的线索记录 */
    public async updateClueReported(params: IUpdateClueReported) {
        const result = await xhr({
            method: 'put',
            url: '/clue/report',
            params: params
        })
        return result
    }

    /** 更新已被报道的线索记录 */
    public async deleteClueReported(params: IDeleteClueReported) {
        const result = await xhr({
            method: 'delete',
            url: '/clue/report',
            params: params
        })
        return result
    }

    /** 获取发布会申请列表 */
    public async getReleaseList(params: IGetReleaseListParams) {
        const result = await xhr({
            method: 'get',
            url: '/conference/list',
            params: params
        })
        return result
    }

    /** 获取发布会申请详情 */
    public async getReleaseDetail(params: IGetReleaseDetailParams) {
        const result = await xhr({
            method: 'get',
            url: '/conference',
            params: params
        })
        return result
    }

    /** 获取发布会申请列表 */
    public async updateRelease(params: IUpdateReleaseParams) {
        const result = await xhr({
            method: 'put',
            url: '/conference',
            params: params
        })
        return result
    }

    /** 获取审核不通过原因列表 */
    public async getNotPassReasons(params: any) {
        const result = await xhr({
            method: 'get',
            url: '/clue/not_pass_reasons',
            params: params
        })
        return result
    }

    /** 新增审核不通过原因 */
    public async addNotPassReason(params: any) {
        const result = await xhr({
            method: 'post',
            url: '/clue/not_pass_reason',
            params: params
        })
        return result
    }

    /** 编辑审核不通过原因 */
    public async editNotPassReason(params: any) {
        const result = await xhr({
            method: 'put',
            url: '/clue/not_pass_reason',
            params: params
        })
        return result
    }

    /** 删除审核不通过原因 */
    public async deleteNotPassReason(params: any) {
        const result = await xhr({
            method: 'delete',
            url: '/clue/not_pass_reason',
            params: params
        })
        return result
    }
}

// 实例化后导出，全局单例
export default new ClueService()
